import useDiscard from "../../../../useDiscard";
import useMap from "../../../../utils/useMap";
import useWeakMap from "../../../../utils/useWeakMap";

const useGroupControl = (() => {
    const caching = useWeakMap();

    const onDiscardProp = prop => caching.get(prop);
    window['useGroupControl'] = caching;
    /**
     * @param {string} name
     * @param {object} props
     * @param {Node} node
     * @returns { {controls: Array<HTMLElement>} }
     */
    return (name, props, node) => {
        if (!caching.has(props)) {
            caching.set(props, useMap());
            useDiscard(props, onDiscardProp);
        }
        const groupControls = caching.get(props);
        if (!groupControls.has(name)) {
            groupControls.set(name, new Set())
        }
        const controls = groupControls.get(name);
        controls.add(node);

        const rs = {}
        Object.defineProperty(rs, 'controls', {
            get() {
                return Array.from(controls);
            }
        })
        return rs
    }
})()

export default useGroupControl;